/* eslint-disable max-len */
import React from 'react';
import { HiStop } from 'react-icons/hi';

function PlayMic() {
  return (
    <div className="flex justify-center items-center">
      <div className="flex justify-center items-center bg-[#dc2626] rounded-full w-16 h-16 animation-pulse">
        <HiStop className="text-3xl text-white" />
      </div>
    </div>
  );
}

export default PlayMic;
